import { useEffect } from "react";
import LandingPageComponent from "../../components/landing_page";
import SEO from "../../components/SEO";

export default function LandingPage({detectPageChange}){

    
useEffect(()=>{
    detectPageChange(window.location.pathname)
     
  },[])
  
    return (
        <>
            <SEO
                title="81Handyman — Find Trusted Local Handymen"
                description="Find trusted local handymen for home repairs, maintenance, renovations, and improvement projects with 81Handyman."
                path="/"
            />

            <LandingPageComponent />
        </>
    )
}